import { render, staticRenderFns } from "./PlaytestColumn.vue?vue&type=template&id=6737fe74"
import script from "./PlaytestColumn.vue?vue&type=script&lang=js"
export * from "./PlaytestColumn.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports